<div class="unlock-chat-dialog">
  <header class="dialog-header">
    <h1>
      <span class="clinician-name">{{ clinicianName }}</span> was messaging patient
      <span class="patient-name">{{ patientName }}</span>
      {{ minutesAgo }} minutes and {{ secondsAgo }} seconds ago, message locking for this patient will expire in
      {{ expireMinutes }} minutes and {{ expireSeconds }} seconds
    </h1>
  </header>

  <footer class="dialog-footer">
    <button class="btn btn-default" (click)="close()">Close</button>
    <button class="btn btn-success" (click)="unlock()">Unlock</button>
  </footer>
</div>
